"use client";

import { CashbackCard } from "./CashbackCard";
import { ClaimableNowCard } from "./ClaimableNowCard";
import { PriorityTicketsCard } from "./PriorityTicketsCard";
import { WheelTicketsCard } from "./WheelTicketsCard";

/**
 * Two columns rather than one row: on desktop this sits inside a half-width
 * grid column, too narrow for four cards abreast.
 *
 * Splits at `lg` (1280px), not `sm`: this app sets `--breakpoint-sm` to 360px,
 * so an `sm:` split would put two cards side by side on every phone, and below
 * `lg` the parent column is itself only ~358px. Cards carry a 48px balance
 * figure that has no break opportunity, so they need the full column until then.
 */
export const ProfileRewards = () => (
  <div className="grid w-full grid-cols-1 gap-3.5 lg:grid-cols-2">
    <ClaimableNowCard />
    <WheelTicketsCard />
    <PriorityTicketsCard />
    <CashbackCard />
  </div>
);
